import groq from "groq";

export const recommendationsGroqFilter = groq`
  *[_type == 'recommendation']
    | order(_createdAt desc)
`;
